import classNames from 'classnames';
import * as React from 'react';
import type { ComboSelectorPartialBaseProps } from '../../types';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import styles from './ComboSelectorButtonGroup.module.css';

type ComboSelectorButtonGroupProps = ComboSelectorPartialBaseProps;

export const ComboSelectorButtonGroup: React.FC<ComboSelectorButtonGroupProps> = props => {
    const { labelId, onChange, options, currentValue, colorVariant } = props;

    const buttonTier = colorVariant === 'light' ? ButtonTier.Tertiary : ButtonTier.Primary;

    return (
        <div className={styles.ComboSelectorButtonGroup} aria-describedby={labelId}>
            {Array.from(options).map(([value, buttonLabel]) => {
                const isSelected = value === currentValue;
                const buttonType = isSelected ? ButtonType.Solid : ButtonType.Outline;

                return (
                    <Button
                        key={value}
                        className={classNames(styles.Button, isSelected && styles['Button--selected'])}
                        type={buttonType}
                        tier={buttonTier}
                        size={ButtonSize.Medium}
                        onClick={() => onChange(value)}
                    >
                        {buttonLabel}
                    </Button>
                );
            })}
        </div>
    );
};
